import { useCallback } from "react";

import AIPlayerSummaryErrorStateView from "./AIPlayerSummaryErrorStateView";

/**
 * Props interface for AIPlayerSummaryErrorStateContainer component
 */
interface AIPlayerSummaryErrorStateContainerProps {
  error: string;
  isDark: boolean;
  isSmallScreen: boolean;
  onRefresh: () => void;
}

/**
 * AIPlayerSummaryErrorStateContainer component - manages error state logic
 *
 * Handles the error state display for AI player summary generation failures.
 * Provides a "Try Again" button that triggers regeneration of the summary.
 * @param props - Component props
 * @param props.error - Error message to display
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.onRefresh - Callback to refresh and regenerate the summary
 */
function AIPlayerSummaryErrorStateContainer({
  error,
  isDark,
  isSmallScreen,
  onRefresh,
}: AIPlayerSummaryErrorStateContainerProps) {
  const handleRefresh = useCallback(() => {
    onRefresh();
  }, [onRefresh]);

  return (
    <AIPlayerSummaryErrorStateView
      error={error}
      isDark={isDark}
      isSmallScreen={isSmallScreen}
      onRefresh={handleRefresh}
    />
  );
}

export default AIPlayerSummaryErrorStateContainer;
